import { useState } from 'react'
import { Navbar } from '../components/Navbar'
import { BottomNav, NavItemProps } from '../components/BottomNav'
import { SidePanel } from '../components/SidePanel'
import { LayoutProps } from './Layout.types'
import { BiSolidDashboard, BiSolidComponent, BiSolidFile } from 'react-icons/bi'
import { type Language } from '../components/LanguageDropdown/LanguageDropdown.types'
import { DEFAULT_LANGUAGE, LANGUAGES } from '../i18n/constants'
import styles from './Layout.module.css'

const defaultLanguages: Language[] = LANGUAGES

const defaultNavItems: NavItemProps[] = [
  {
    label: 'Home',
    icon: <BiSolidDashboard />,
    path: '/',
    active: false,
    onClick: () => {},
  },
  {
    label: 'Number Set',
    icon: <BiSolidComponent />,
    path: '/number-set',
    active: false,
    onClick: () => {},
  },
  {
    label: 'Result',
    icon: <BiSolidFile />,
    path: '/result',
    active: false,
    onClick: () => {},
  },
]

const Layout = ({
  children,
  // Layout props
  // Navbar props
  logo = '',
  username = '',
  balance,
  isMaskedBalance = false,
  onLogoClick = () => {},
  isUpdating = false,
  onRefreshClick = () => {},
  cooldown = 0,
  isDisabled = false,
  // SidePanel props
  currentLang = DEFAULT_LANGUAGE,
  onLanguageChange = () => {},
  languages = defaultLanguages,
  // BottomNav props
  navItems = defaultNavItems,
  activePath = '/',
  onNavClick = () => {},
}: LayoutProps) => {
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false)

  const handleAvatarClick = () => {
    setIsSidePanelOpen(true)
  }

  const handleCloseSidePanel = () => {
    setIsSidePanelOpen(false)
  }

  return (
    <div className="bg-[var(--bg-theme)] min-h-screen flex flex-col">
      <Navbar
        logo={logo}
        username={username}
        balance={balance}
        isMaskedBalance={isMaskedBalance}
        onLogoClick={onLogoClick}
        onRefreshClick={onRefreshClick}
        isUpdating={isUpdating}
        cooldown={cooldown}
        isDisabled={isDisabled}
        onAvatarClick={handleAvatarClick}
        currentLang={currentLang}
        onLanguageChange={onLanguageChange}
        languages={languages}
      />

      <main className={`flex-grow relative ${styles.main}`}>
        <div
          className={`flex flex-col justify-center items-center max-w-[90rem] mx-auto px-4 sm:px-8 lg:px-16 xl:px-24 2xl:px-0 pb-24 ${styles.container}`}
        >
          {children}
        </div>
      </main>

      <BottomNav
        navItems={navItems}
        activePath={activePath}
        onNavClick={onNavClick}
      />

      {/* SidePanel - Only visible on mobile screens */}
      <div className="sm:hidden">
        <SidePanel
          isOpen={isSidePanelOpen}
          onClose={handleCloseSidePanel}
          username={username}
          currentLang={currentLang}
          onLanguageChange={onLanguageChange}
          languages={languages}
          logo={logo}
        />
      </div>
    </div>
  )
}

export default Layout
